var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.convertPrice)?[_vm._v("\n        "+_vm._s(_vm._f("price")(_vm.price))+"\n    ")]:[_vm._v("\n        "+_vm._s(_vm._f("priceFormat")(_vm.price.amount,_vm.price.currency))+"\n    ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }